import type { INavItemBadgeType } from "@similarweb/ui-components";

import { onSubSectionClick } from "app/components/sidebar3/SideBarItems";
import { navigateToReport } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import type { EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";
import DurationService from "app/services/DurationService";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { withCampaignAwareNavigation } from "./listItemsUtils";

export const handleAIBrandVisibilityClick = (
    state: EPrimarySideBar3StateType,
    id?: string,
    itemCounter?: number,
    isLocked?: boolean,
    badgeType?: INavItemBadgeType,
    ParentTrackName?: string,
): void => {
    if (
        withCampaignAwareNavigation(state, (campaign) => {
            const currentDuration: unknown = proNavigator.getParams()?.duration;
            const isCustomDuration =
                typeof currentDuration === "string" &&
                currentDuration.includes("-") &&
                DurationService.getDurationData(currentDuration).raw.isCustom;

            if (isCustomDuration) {
                navigateToReport(campaign, undefined, undefined, {}, { preserveCurrentDuration: false });
                return;
            }

            navigateToReport(campaign);
        })
    ) {
        return;
    }

    onSubSectionClick(state, id, itemCounter, isLocked, badgeType, ParentTrackName);
};
